import cx from "classnames";
import type { FC, ReactNode } from "react";

export type ToolbarProps = {
	children?: ReactNode;
	spacing?: "default" | "none";
};

export const ToolbarButton = ({ children }) => {
	return <button>{children}</button>;
};

export const Toolbar: FC<ToolbarProps> = ({ children, spacing = "default" }) => {
	return (
		// Extra div is required for both shadow border and shadow
		<div className="rounded shadow-lg">
			<div
				className={cx(
					"flex",
					"items-stretch",
					"min-h-8",
					"rounded",
					"bg-primary-raised",
					"shadow-border-default",
					"flex-wrap",
					{ "px-1.5": spacing === "default" }
				)}
			>
				{children}
			</div>
		</div>
	);
};
